import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actionTypes from './../../store/actions/helpAction';

/**
 * Main Heading component
 */
class MainHeadingOutput extends Component {
  render() {
    const {heading} = this.props.data;
    const {openModalWithContent} = this.props;

    return (
      <div className="nppe2-fc-main-heading-output">

        <div className="nppe2-fc-main-heading-output__red"></div>
        
        <div className="nppe2-fc-main-heading-output__text">
          <h1>{heading}</h1>
        </div>

        <div className="nppe2-fc-main-heading-output__info"
          onClick={openModalWithContent}></div>

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.helpReducer.open,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    openModalWithContent: (key) => dispatch({
      type: actionTypes.OPEN_MODAL_WITH_CONTENT,
      key: "General",
      open: true,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainHeadingOutput);
